var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('form',{attrs:{"id":"payment-form"}},[_c('div',{attrs:{"id":"payment-element"}}),_c('div',{attrs:{"id":"error-message"}})])])
}]

export { render, staticRenderFns }